'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    navSubItemGroupClassNames: function() {
        return navSubItemGroupClassNames;
    },
    useNavSubItemGroupStyles_unstable: function() {
        return useNavSubItemGroupStyles_unstable;
    }
});
const _react = require("@griffel/react");
const navSubItemGroupClassNames = {
    root: 'fui-NavSubItemGroup'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        Bnnss6s: "fi64zpg",
        Bz10aip: "f1yj8dow",
        B68tc82: 0,
        Bmxbyg5: 0,
        Bpg54ce: "f1a3p1vp"
    }
}, {
    d: [
        ".fi64zpg{flex-shrink:0;}",
        ".f1yj8dow{transform:translateZ(0);}",
        [
            ".f1a3p1vp{overflow:hidden;}",
            {
                p: -1
            }
        ]
    ]
});
const useNavSubItemGroupStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(navSubItemGroupClassNames.root, styles.root, state.root.className);
    return state;
};
